import { gql } from 'src/__generated__'

export default gql(`
  mutation addFoodToOffer($data: AddFoodToOfferInput!) {
    addFoodToOffer(data: $data) {
      id
    }
  }
`)
